import { render, staticRenderFns } from "./page5.vue?vue&type=template&id=1cde4410&scoped=true&"
import script from "./page5.vue?vue&type=script&lang=js&"
export * from "./page5.vue?vue&type=script&lang=js&"
import style0 from "./page5.vue?vue&type=style&index=0&id=1cde4410&lang=less&scoped=true&"
import style1 from "./page5.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cde4410",
  null
  
)

export default component.exports